module.exports = __webpack_public_path__ + "img/task-4-l.02b6fca4.png";